import React from 'react';

import { Button } from "antd";

const Phone = props => {
  return (
    <div style={{display:'flex',height:'100%',justifyContent:'center',alignItems:'center'}}>
      <Button onClick={() => window.location.href ='tel:18755181550'}>拨打电话</Button>
    </div>
  );
};

export default Phone;
